import React from 'react';
import { Anchor } from '../types';

interface Props {
  item: Anchor;
  isActive: boolean;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const TocItem = ({ item, isActive, onClick }: Props) => {
  return (
    <li
      className={`toc-items ${isActive ? 'active' : ''}`}
      data-test-id="toc-items"
    >
      <a href={`#${item.id}`} title={item.text} onClick={onClick}>
        {item.text}
        {isActive && (
          <div
            className="toc-current-indicator"
            data-test-id="toc-indicator"
          ></div>
        )}
      </a>
    </li>
  );
};

export default TocItem;
